import { isFeatureEnabled } from 'owa-feature-flags';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import { lazyIsReadingPaneConversationEnabled } from 'owa-mail-unstacked';

export default function shouldShowUnstackedReadingPane(): boolean {
    // Show unstacked reading pane if:
    // - Feature flag is enabled
    // - React list view type is conversation
    // - Reading pane conversation is disabled
    if (isFeatureEnabled('mon-rp-unstackedConversation')) {
        const globalListViewTypeReact = getUserConfiguration()?.UserOptions
            ?.GlobalListViewTypeReact;
        return (
            globalListViewTypeReact == ReactListViewType.Conversation &&
            !getIsRPConversationEnabled()
        );
    } else {
        return false;
    }
}

function getIsRPConversationEnabled(): boolean {
    // Try to import the actual util function, if it is not imported yet, return the default for now
    // This is temporary until we remove the direct dependency between owa-outlook-service-options-store and owa-outlook-service-option
    // VSO: 105165 https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/105165
    const isReadingPaneConversationEnabled = lazyIsReadingPaneConversationEnabled.tryImportForRender();
    let isConversationEnabled = isReadingPaneConversationEnabled
        ? isReadingPaneConversationEnabled()
        : null;
    if (isConversationEnabled == null) {
        const isNativeHost = isHostAppFeatureEnabled('useNativeHostRPConversationOption');
        isConversationEnabled = !isNativeHost;
    }

    return isConversationEnabled;
}
